import ListTemplate from './ListTemplate';

export default ListTemplate;
